define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-tv-our-story-moley-awards';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvOurStoryMoleyAwardsContentSubheaderCls, 'animate__slideInDown', 'tv-our-story-moley-awards', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvOurStoryMoleyAwardsBkgLeftCls, 'animate__slideInLeft', 'tv-our-story-moley-awards', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvOurStoryMoleyAwardsBkgRightCls, 'animate__slideInRight', 'tv-our-story-moley-awards', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvOurStoryMoleyAwardsImgLeftCls, 'animate__slideInLeft', 'tv-our-story-moley-awards', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvOurStoryMoleyAwardsImgRightCls, 'animate__slideInRight', 'tv-our-story-moley-awards', {});
            };

            view.bind = function () {

            };

            view.methods = {
                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                }
            };

            /* custom events */

            // pubSub.subscribe('view/updateCharacterContent', view.methods.updateCharacterContent);

            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();


        return module;

    });